$(document).ready(function() {

    let wrapper = $("div#register_stock_form_wrapper");
    let ajaxPathRegisterStock = '/action/logistics/register-stock';

    // Show/hide product filter frame
    $(wrapper).on('change', 'select.register_stock_select', function () {
        saveRegisterStock(
            $(this).attr('sync_code'),
            $(this).attr('register_number'),
            $(this).val(),
            $(this)
        );
    });

    function saveRegisterStock(syncCode, registerNumber, stockId, selectElement) {
        if (!$.isNumeric(registerNumber) || registerNumber <= 0) {
            return false;
        }
        if (syncCode.length !== 12) {
            return false;
        }

        ajaxLockActive = true;
        $.ajax({
            type: 'POST',
            url: ajaxPathRegisterStock,
            data: {
                stock_id: stockId,
                sync_code: syncCode,
                register_number: registerNumber
            }
        }).success(function () {
            selectElement.notify('Lagret', {position:"left", className: "success"});
        }).error(function () {
            selectElement.notify('Kunne ikke lagre!', {position:"left", className: "error"});
        }).always(function () {
            // Not implemented
        });
    }

});